import css from 'styled-jsx/css';

export default css`
  .Lightbox {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: #00000095;
    z-index: 1000000000;
    overflow: auto;
    outline: none;
  }

  :global(.Lightbox__image--landscape) {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 100%;
    height: auto;
    max-height: 100vh;
    object-fit: contain;
  }

  :global(.Lightbox__image--portrait) {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    height: 100%;
    width: auto;
    max-width: 100vw;
    object-fit: contain;
  }

  :global(.Lightbox__image--loading) {
    visibility: hidden;
  }

  .Lightbox__caption {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #00000095;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1.5rem;
    z-index: 1000;
    color: #fff;
  }

  .Lightbox__icon {
    position: absolute;
    filter: drop-shadow(2px 2px 1px #333);
    font-size: 25px;
    color: #fff;
    outline: none;
  }

  .Lightbox__prev {
    top: 50%;
    transform: translateY(-50%);
    left: 1rem;
    font-size: 35px;
  }

  .Lightbox__next {
    top: 50%;
    transform: translateY(-50%);
    right: 1rem;
    font-size: 35px;
  }

  .Lightbox__close {
    top: 1.5rem;
    right: 1.5rem;
    z-index: 999;
  }
`;
